import {
  Actions,
  CLEAR_INFO_IN_BLACKLIST,
  EXPAND_MSISDN,
  GET_BLACKLIST,
  GET_BLACKLIST_SUCCESS,
  GET_INFO_IN_BLACKLIST_SUCCESS
} from './blacklist.actions';
import { createSelector } from 'reselect';
import { DefaultParams } from './blacklist.config';
import { Blacklist, BlacklistRequest } from './blacklist';

export interface IBlacklistState {
  params: BlacklistRequest;
  list: {
    data: Blacklist[];
    total: number;
  };
}

export const initialState: IBlacklistState = {
  params: new DefaultParams(),
  list: {
    data: [],
    total: 0
  }
};

const changeFieldInElement = (state, msisdn, data): IBlacklistState => {
  return {
    ...state,
    list: {
      ...state.list,
      data: state.list.data.map(element => (element.msisdn === msisdn ? { ...element, ...data } : element))
    }
  };
};

export function blacklistReducer(state = initialState, action: Actions): IBlacklistState {
  switch (action.type) {
    case GET_BLACKLIST_SUCCESS:
      return {
        ...state,
        list: action.payload
      };

    case EXPAND_MSISDN:
      return changeFieldInElement(state, action.payload.element.msisdn, {
        expanded: action.payload.expanded
      });

    case GET_INFO_IN_BLACKLIST_SUCCESS:
      return changeFieldInElement(state, action.payload[0].msisdn, { additional: action.payload });

    case CLEAR_INFO_IN_BLACKLIST:
      return changeFieldInElement(state, action.payload.element.msisdn, { additional: null });

    case GET_BLACKLIST:
      return {
        ...state,
        params: action.payload
      };

    default: {
      return state;
    }
  }
}

export const getList = state => state.list.data;
export const getListTotal = state => state.list.total;
export const getParams = state => state.params;
export const getMainBlacklistSelector = state => state.blacklist;
export const getBlacklistSelector = createSelector(getMainBlacklistSelector, getList);
export const getBlacklistTotalSelector = createSelector(getMainBlacklistSelector, getListTotal);
export const getBlacklistParamsSelector = createSelector(getMainBlacklistSelector, getParams);
